import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar } from '@mui/material';
import { Alert } from "@material-ui/lab";

import UserConfigurationDetails from './../../components/UserConfigurationDetails';
import { addNewUser, deleteUser, editUser, reActive, resetNewUser, getListOfAccts, clearAllUserListMessages, toggleUser } from "../../store/actions"

import spinner from "../../assets/images/aws/loadingGif.gif";
import { ExtractCountryCallingCode, ExtractPhoneNumber } from '../../components/UserConfigurationDetails/ExtractPhoneNumber';


const UsersConfig = () => {
    const dispatch = useDispatch()
    const licensing = useSelector((state) => state.licensing);
    const acctList = useSelector((state) => state.acctList);
    const { accounts, organizations, orgAndAccountsLoading, orgAndAccountsError } = useSelector((state) => {
        console.log('--== state.orgAccount ', state.orgAccount);
        const { accounts, organizations, loading, error } = state.orgAccount
        return {
            accounts, 
            organizations: organizations && organizations.length > 0 ? organizations[0] : {},
            orgAndAccountsLoading: loading,
            orgAndAccountsError: error,
        }
    });
    const userList = useSelector((state) => state.userList);
    const profile = useSelector((state) => state.profile);
    console.log('-- UserConfig ** ', licensing, acctList, userList);
    const {
      addNewUserError,
      addNewUserLoading,
      addNewUserMessage,
      status, reActiveUser,
      editUserError,
      editUserLoading,
      editUserMessage,
      deleteUserError,
      deleteUserLoading,
      deleteUserMessage,
      toggleUserError,
      toggleUserLoading,
      toggleUserMessage,
    } = userList;
    const addNewUserResponse = {
      addNewUserError,
      addNewUserLoading,
      addNewUserMessage,
      status,
    };
    const editUserResponse = {
      editUserError,
      editUserLoading,
      editUserMessage,
    };

    const getRoleAccess = useCallback(() => {
        if (licensing && licensing.data.isLicensingComplete && profile && profile.userRoles && profile.userRoles.includes("Administrator")) {
            return 0;
        }

        return -1;
    });
    useEffect(() => {
        
            dispatch(getListOfAccts());
        
    }, [])

    // useEffect(() => {
    //     if ((addNewUserResponse && addNewUserResponse.status === 200) || (reActiveUser && reActiveUser?.status === 200)) {
    //         dispatch(getListOfAccts());
    //     }
    // }, [addNewUserResponse, reActiveUser])

    useEffect(() => {
      if (
        addNewUserMessage ||
        editUserMessage ||
        deleteUserMessage ||
        toggleUserMessage ||
        (reActiveUser && reActiveUser?.status === 200)
      ) {
        dispatch(getListOfAccts());
      }
    }, [addNewUserMessage, editUserMessage, deleteUserMessage, toggleUserMessage, reActiveUser]);

    //For clearing messages after Snackbars are displayed
    useEffect(() => {
        if ( deleteUserError || deleteUserMessage || toggleUserError || toggleUserMessage) {
            setTimeout(() => {
                console.log("About to call clearAllUserListMessages");
                dispatch(clearAllUserListMessages());
          }, 10000); // Hide all messages after 10 seconds
        }
    }, [deleteUserMessage, deleteUserError, toggleUserMessage, toggleUserError]);

    const handleSubmit = (values) => {
        console.log('--== handleSubmit ', values);
        if (values.isEditFlow) {
            dispatch(editUser(values));
        } else {
            dispatch(addNewUser(values));
        }

    }
    const hanldeResetNewUser = () => {
        dispatch(resetNewUser())
    }

    const onReActive = (payload) => {
        dispatch(reActive(payload));
    }

    const onDelete = (payload) => {
        const acccodes = payload?.listacct?.map(
            account => ({ acccode: account.accountCode })
        ) || [];
        const resourceGroupDTOS = payload?.userGroup?.map(
            userGroup => ({ resourcename: userGroup.resourcename })
        ) || [];
        const userRolesDTOS = payload?.roles || [];
        const deleteApiPayload = { 
            firstName: payload.firstname,
            lastName: payload.lastName,
            userName: payload.username,
            // password: null,
            email: payload.email,
            username: payload.email,
            country: payload.country,
            phoneNumber: ExtractPhoneNumber(payload.phoneNumber),
            countryCode: ExtractCountryCallingCode(payload.phoneNumber),
            orgCode: organizations.orgcode,
            acccodes: acccodes,
            userRolesDTOS: userRolesDTOS,
            resourceGroupDTOS: resourceGroupDTOS, 
            action: payload.action,
        }
        // console.log("delete payload", deleteApiPayload);
        dispatch(deleteUser(deleteApiPayload));
    }

    const onToggle = (payload) => {
        dispatch(toggleUser(payload));
    }

    // Check if customer is true in selectedOrganization
    const isCustomer = () => {
        const selectedOrganizationStr = localStorage.getItem('selectedOrganization');
        if (selectedOrganizationStr) {
            try {
                const selectedOrganization = JSON.parse(selectedOrganizationStr);
                return selectedOrganization.customer === true;
            } catch (error) {
                console.error('Error parsing selectedOrganization:', error);
                return false;
            }
        }
        return false;
    };

    // Extract domain from email helper function
    const extractDomain = (email) => {
        if (!email || typeof email !== 'string') return null;
        const parts = email.split('@');
        return parts.length === 2 ? parts[1].toLowerCase() : null;
    };

    // Filter users based on organization's primary email domain (only if customer: true)
    const getFilteredUsersConfig = () => {
        // Only filter if customer is true
        if (!isCustomer()) {
            return acctList.usersConfig || [];
        }

        if (!organizations || !organizations.orgprimaryemail || !acctList.usersConfig) {
            return acctList.usersConfig || [];
        }

        const orgDomain = extractDomain(organizations.orgprimaryemail);
        if (!orgDomain) {
            return acctList.usersConfig || [];
        }

        return (acctList.usersConfig || []).filter(user => {
            if (!user.email) return false;
            const userDomain = extractDomain(user.email);
            return userDomain === orgDomain;
        });
    };

    const filteredUsersConfig = getFilteredUsersConfig();

    return (
        <React.Fragment>
            { (licensing.loading || acctList.loading || orgAndAccountsLoading || userList.loading || profile.loading) && 
                    (<React.Fragment>
                        <div
                            style={{
                                display: "flex",
                                direction: "row",
                                alignContent: "center",
                                alignItems: "center",
                                justifyContent: "center",
                                justifyItems: "center",
                                height: "80vh",
                            }}
                        >
                            <img src={spinner} width="32px" alt="Spinner" />
                        </div>
                    </React.Fragment>)            
            }
            { (licensing.error || acctList.error || orgAndAccountsError || userList.error || profile.error) && 
                (<React.Fragment>
                    <div
                        style={{
                            display: "flex",
                            direction: "row",
                            alignContent: "center",
                            alignItems: "center",
                            justifyContent: "center",
                            justifyItems: "center",
                            height: "80vh",
                            color: "red"
                        }}
                    >
                        <div>Something went wrong! Refresh the page.</div>
                    </div>
                </React.Fragment>)            
            }
            {
                licensing && licensing.data && accounts && organizations && (
                    <UserConfigurationDetails
                        licensing={licensing.data}
                        accounts={accounts}
                        organizations={organizations}
                        usersConfig={filteredUsersConfig}
                        roleAccess={getRoleAccess()}
                        handleSubmit={handleSubmit}
                        onReActive={onReActive}
                        onDelete={onDelete}
                        onToggle={onToggle}
                        addNewUserResponse={addNewUserResponse}
                        editUserResponse={editUserResponse}
                        hanldeResetNewUser={hanldeResetNewUser}
                    />
                )
            }

            <Snackbar
                open={deleteUserError!==null}
                autoHideDuration={5000}
            >
                <Alert severity="error">{deleteUserError}</Alert>
            </Snackbar>
            <Snackbar
                open={deleteUserMessage!==null}
                autoHideDuration={5000}
            >
                <Alert severity="success">{deleteUserMessage}</Alert>
            </Snackbar>        
            <Snackbar
                open={toggleUserError!==null}
                autoHideDuration={5000}
            >
                <Alert severity="error">{toggleUserError}</Alert>
            </Snackbar>
            <Snackbar
                open={toggleUserMessage!==null}
                autoHideDuration={5000}
            >
                <Alert severity="success">{toggleUserMessage}</Alert>
            </Snackbar>
        </React.Fragment>
    )
}

export default UsersConfig;